<div
    class="input-line-form__box"
    [class.invalid]="isInvalid"
    [class.readonly]="readonly"
>
    <div class="input-line-form__name" *ngIf="labelName">
        {{labelName | translate}}
        <span *ngIf="isRequired">*</span>
    </div>
    <input
        [name]="name"
        [id]="id"
        [placeholder]="placeholder ? placeholder : ''"
        [formControl]="lineControl"
        [type]="type || 'text'"
        [attr.tabindex]="tabindex ?? null"
        [spellcheck]="spellcheck"
        [attr.autocomplete]="autocomplete || null"
    />
</div>
